"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

exports.implementation = function Plugin() {
  _classCallCheck(this, Plugin);
};